import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 11h10" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 18a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 16.5v1.5l.5 .5" })
	]
});
export { SvgCalendarClock as ReactComponent };
